exports.components = {
  "component---src-pages-index-js": () => import("./../../../src/pages/index.js" /* webpackChunkName: "component---src-pages-index-js" */),
  "component---src-pages-ssr-js": () => import("./../../../src/pages/ssr.js" /* webpackChunkName: "component---src-pages-ssr-js" */),
  "component---src-templates-dsg-js": () => import("./../../../src/templates/dsg.js" /* webpackChunkName: "component---src-templates-dsg-js" */)
}

